import selectImage from "../libs/select-images";

const drawCanvasFromUrl = function(canvas, url)
{
    const ctx = canvas.getContext('2d')
    const image = new Image()
    image.onload = () => {
        ctx.canvas.width = image.width
        ctx.canvas.height = image.height
        ctx.drawImage(image, 0, 0, image.width, image.height)
    }
    image.src = url

}

$(document).on('click', '[data-action="uploadImage"]', function () {
    const $this = $(this)
    const cont = $this.closest('.image-editor-container').length
        ? $this.closest('.image-editor-container')
        : $this
    editCover({
        type: cont.data('type'),
        modalSize: cont.data('modal-size'),
        title: cont.data('modal-title'),
        submit: (modal, cropper) => {
            if (!cropper) {
                return false
            }
            // const field = cont.find('canvas').data('field')
            const dCont = $this.closest('.image-data-container')
            dCont.data('image-data', {
                type: 'canvas',
            })
            dCont.data('canvas', cropper.getCroppedCanvas(window.sizes[cont.data('type')].crop))
            cont.find('canvas').replaceWith(dCont.data('canvas'))
            modal.modal('hide')
            return false;
        }
    })
})


$(document).on('click', '[data-action="selectImage"]', function () {
    selectImage().then(url => {
        if (url) {
            const container = $(this).closest('.image-data-container')
            container.data('image-data', {
                type: 'url',
                url: url,
            })
            const $canvas = container.find('canvas')
            if ($canvas.length > 0) {
                drawCanvasFromUrl($canvas[0], url)
            }
        }
    })
    return false
})

export async function attachGroupCovers(form, formData) {
    formData.delete('image3');
    return Promise.all([
        ...form.find('.image-data-container').map(function () {
            formData.delete($(this).data('field'))
            const data = $(this).data('image-data')
            if (!data) {
                return true
            }
            if (data.type === 'url') {
                formData.append($(this).data('field'), data.url)
                return true
            }
            if (data.type === 'canvas') {
                return new Promise(resolve => {
                    $(this).data('canvas').toBlob(blob => {
                        formData.append($(this).data('field'), blob)
                        resolve()
                    })
                })
            }
        }),
        ...form.find('canvas.changed').map(function () {
        })
    ]);
}

$(document).on('drop', '.image-editor-container', function (e) {
    e.preventDefault()
    const $this = $(this)
    if (e.originalEvent.dataTransfer.files.length === 0) {
        return
    }
    editCover({
        type: $this.data('type'),
        modalSize: $this.data('modal-size'),
        title: $this.data('modal-title'),
        file: e.originalEvent.dataTransfer.files[0] || '',
        submit: (modal, cropper) => {
            if (!cropper) {
                return false
            }
            $(this).closest('.image-data-container').data('image-data', {
                type: 'canvas',
            })
            $this.data('canvas', cropper.getCroppedCanvas(window.sizes[$this.data('type')].crop))
            $this.find('canvas').replaceWith($this.data('canvas'))
            modal.modal('hide')
            return false;
        }
    })
})

$(document).on('dragover', '.image-editor-container', function (e) {
    e.preventDefault()
})

$(document).on('docready', function(e) {
    $('.image-data-container', e.detail).each(function() {
        const container = $(this)
        const canvas = container.find('canvas')
        if (canvas.length > 0 && container.data('imageUrl')) {
            drawCanvasFromUrl(canvas[0], container.data('imageUrl'))
        }
    })

})
